import { render } from "./insure-daily-company.vue?vue&type=template&id=3bc03882&scoped=true&ts=true"
import script from "./insure-daily-company.vue?vue&type=script&lang=ts"
export * from "./insure-daily-company.vue?vue&type=script&lang=ts"

import "./insure-daily-company.vue?vue&type=style&index=0&id=3bc03882&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc03882"]])

export default __exports__